import { FC } from 'react';
import styled, { ThemeColors } from 'styled-components';
import Flex from './Flex';

const sizes = {
    small: '1.2em',
    medium: '2.5em',
    large: '4em',
};

const thickness = {
    small: '1px',
    medium: '2px',
    large: '3px',
};

type SpinnerProps = {
    className?: string;
    color?: keyof ThemeColors;
    useFullHeight?: boolean;
    center?: boolean;
    size?: 'small' | 'medium' | 'large';
};
const Spinner: FC<SpinnerProps> = ({ className, color, useFullHeight = true, center, size }) => (
    <Flex className={useFullHeight ? 'h-100' : undefined} align="center" justify={center ? 'center' : 'start'}>
        <StyledSpinner color={color} className={className || undefined} size={size} />
    </Flex>
);

const StyledSpinner = styled.span<SpinnerProps>`
    /* https://cssloaders.github.io/ */
    width: ${({ size }) => (size ? sizes[size] : sizes['small'])};
    height: ${({ size }) => (size ? sizes[size] : sizes['small'])};
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;

    &::before,
    &::after {
        content: '';
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        border-style: solid;
        border-color: #b1b1b1;
        border-width: ${({ size }) => (size ? thickness[size] : thickness['small'])};
        animation: prixClipFix 3s alternate infinite;
    }
    &::after {
        inset: 4px;
        border-color: ${({ theme, color }) =>
            theme.colors ? (color ? theme.colors[color] : theme.colors.attention) : '#ff3d00'};
        animation: prixClipFix 3.5s alternate infinite, rotate 0.5s linear infinite reverse;
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes prixClipFix {
        0% {
            clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
        }
        25% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
        }
        50% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
        }
        75% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
        }
        100% {
            clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
        }
    }
`;

export default Spinner;
